import { GETTOPUP_SUCCESS } from '../types';

const initialState = {
  topupData: []
};

export default function TopupReducer(state = initialState, action) {
  switch (action.type) {
    case GETTOPUP_SUCCESS:
      return {
        ...state,
        topupData: action.payload.data
      };
    default:
      return state;
  }
}
